import React, { useState, useEffect, useRef } from "react";
import { NavLink, Link, useNavigate } from "react-router-dom";
import "./Header.css";
import iitgLogo from "../assets/iitg_logo.png";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [peopleDropdownOpen, setPeopleDropdownOpen] = useState(false);
  const [publicationDropdownOpen, setPublicationDropdownOpen] = useState(false);
  const [contactDropdownOpen, setContactDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const publicationDropdownRef = useRef(null);
  const contactDropdownRef = useRef(null); // Added missing ref for contact dropdown
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Close menu on resize to desktop
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 900) {
        setMenuOpen(false);
        setPeopleDropdownOpen(false);
        setPublicationDropdownOpen(false);
        setContactDropdownOpen(false); // Added contact dropdown
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setPeopleDropdownOpen(false);
      }
      if (publicationDropdownRef.current && !publicationDropdownRef.current.contains(event.target)) {
        setPublicationDropdownOpen(false);
      }
      if (contactDropdownRef.current && !contactDropdownRef.current.contains(event.target)) {
        setContactDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handlePeopleClick = (e) => {
    e.preventDefault();
    setPeopleDropdownOpen(!peopleDropdownOpen);
    setPublicationDropdownOpen(false); // Close other dropdowns
    setContactDropdownOpen(false);
  };

  const handlePublicationClick = (e) => {
    e.preventDefault();
    // Navigate to publication page first
    navigate('/publication');
    // Then toggle dropdown
    setPublicationDropdownOpen(!publicationDropdownOpen);
    setPeopleDropdownOpen(false); // Close other dropdowns
    setContactDropdownOpen(false);
  };

  const handleContactClick = (e) => {
    e.preventDefault();
    // Navigate to contact page first
    navigate('/contact');
    // Then toggle dropdown
    setContactDropdownOpen(!contactDropdownOpen);
    setPeopleDropdownOpen(false); // Close other dropdowns
    setPublicationDropdownOpen(false);
  };

  const closeMobileMenu = () => {
    setMenuOpen(false);
    setPeopleDropdownOpen(false);
    setPublicationDropdownOpen(false);
    setContactDropdownOpen(false);
  };

  return (
    <header className={`header${scrolled ? " header-small" : ""}`}>
      {/* Mobile/Tablet Blue Top Bar Nav */}
      <div className="header-topbar">
        <button
          className="hamburger"
          aria-label="Toggle menu"
          onClick={() => setMenuOpen((prev) => !prev)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
        <div className="header-topbar-title">
          Indian Institute of Technology Guwahati
        </div>
      </div>
      <div>
        <div className="header-inner">
          <img src={iitgLogo} alt="IIT Guwahati Logo" className="iitg-logo" />
          <div className="header-content">
            <div className="header-title">
              <span>B</span>IOMATERIALS & <span>T</span>ISSUE <span>E</span>NGINEERING <span>L</span>ABORATORY
            </div>
            <div className="header-college">
              {/* A UNIT OF EXCELLENCE by DBT, Govt. of India */}
              DBT-funded Unit of Excellence <br/>
              ICMR-funded Centre for Advanced Research
            </div>

            {/* Navigation menu */}
            <nav className={`nav${menuOpen ? " active" : ""}`}>
              <NavLink exact to="/" activeClassName="active" onClick={closeMobileMenu}>
                Home
              </NavLink>

              {/* People Dropdown */}
              <div className="nav-dropdown" ref={dropdownRef}>
                <button
                    className={`nav-dropdown-toggle ${peopleDropdownOpen ? 'dropdown-active' : ''}`}
                    onClick={handlePeopleClick}
                    aria-expanded={peopleDropdownOpen}
                    aria-haspopup="true"
                    type="button"
                  >
                    Research Team
                    <span className="dropdown-arrow">▼</span>
                </button>
                <div className={`nav-dropdown-menu ${peopleDropdownOpen ? 'show' : ''}`}>
                  <Link
                    to="/principal-investigator"
                    onClick={closeMobileMenu}
                    className="dropdown-item"
                  >
                    Principal Investigator
                  </Link>
                  <Link
                    to="/members"
                    onClick={closeMobileMenu}
                    className="dropdown-item"
                  >
                    Members
                  </Link>
                  <Link
                    to="/alumni"
                    onClick={closeMobileMenu}
                    className="dropdown-item"
                  >
                    Phd Alumni
                  </Link>
                </div>
              </div>

              <NavLink to="/research" activeClassName="active" onClick={closeMobileMenu}>
                Research
              </NavLink>

              {/* Publication Dropdown */}
              <div className="nav-dropdown" ref={publicationDropdownRef}>
                <a
                  href="#"
                  className={`nav-dropdown-toggle ${publicationDropdownOpen ? 'dropdown-active' : ''}`}
                  onClick={handlePublicationClick}
                  aria-expanded={publicationDropdownOpen}
                  aria-haspopup="true"
                >
                  Publication
                  <span className="dropdown-arrow">▼</span>
                </a>
                <div className={`nav-dropdown-menu ${publicationDropdownOpen ? 'show' : ''}`}>
                  <Link
                    to="/publication"
                    onClick={closeMobileMenu}
                    className="dropdown-item"
                  >
                    Publications
                  </Link>
                  <Link
                    to="/patents"
                    onClick={closeMobileMenu}
                    className="dropdown-item"
                  >
                    Patents
                  </Link>
                  <Link
                    to="/conference"
                    onClick={closeMobileMenu}
                    className="dropdown-item"
                  >
                    Conference
                  </Link>
                </div>
              </div>

              <NavLink to="/news-activities" activeClassName="active" onClick={closeMobileMenu}>
                News & Activities
              </NavLink>
              
              <NavLink to="/funding" activeClassName="active" onClick={closeMobileMenu}>
                Funding
              </NavLink>

              {/* Contact Dropdown */}
              <div className="nav-dropdown" ref={contactDropdownRef}>
                <a
                  href="#"
                  className={`nav-dropdown-toggle ${contactDropdownOpen ? 'dropdown-active' : ''}`}
                  onClick={handleContactClick}
                  aria-expanded={contactDropdownOpen}
                  aria-haspopup="true"
                >
                  Contact
                  <span className="dropdown-arrow">▼</span>
                </a>
                <div className={`nav-dropdown-menu ${contactDropdownOpen ? 'show' : ''}`}>
                  <Link
                    to="/contact"
                    onClick={closeMobileMenu}
                    className="dropdown-item"
                  >
                    Contact
                  </Link>
                  {/* <Link
                    to="/support-collaboration"
                    onClick={closeMobileMenu}
                    className="dropdown-item"
                  >
                    Support Us / Collaboration
                  </Link> */}
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;